export default __webpack_public_path__ + "static/media/giftBox-img.8e697e51.jpg";